<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Contact Us</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }} >  {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''" 
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <div class="survey-module-right-action">
            <div class="relation-item align-center" v-for="(item,index) in relation_list" :key="index">
              <div class="relation-item-left justify-between align-center">
                <img :src="require(`../assets/img/phone${index}.png`)" alt="">
                <span>{{ item.title }}</span>
              </div>
              <span>{{ item.value }}</span>
            </div>
            <div class="relation-map">
              <el-amap
                  v-if="complete"
                  ref="map"
                  :vid="'amapDemo'"
                  :center="[info.longitude, info.latitude]"
                  :zoom="12"
                  class="amap-demo"
                  style="height: 100%;width: 100%">
                 <el-amap-marker :position="[info.longitude, info.latitude]">
                 </el-amap-marker>
              </el-amap>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getForm} from "@/api/lxfs";
export default {
  data(){
    return{
      menu:{
        title:'联系我们',
        list:[
          {name:'联系方式',id:'1'},
        ]
      },
      menu_id:this.$route.query.id,
      relation_list:[
        {title:'联系电话',value:''},
        {title:'联系邮箱',value:''},
        {title:this.$wangzhan.name=='安徽'?'学会地址':'协会地址',value:''},
      ],
      info:{
        phone: "",
        email: "",
        address: "",
        longitude: "",
        latitude: ""
      },
      complete:false
    }
  },
  created(){
    this.getFun()
  },
  methods:{
    menuFun(id){
      this.menu_id = id
    },
    getFun(){
      getForm({})
      .then((res) => {
        for (let key in this.info) {
          this.info[key] = res.data[key];
        }
        this.relation_list[0].value = res.data.phone
        this.relation_list[1].value = res.data.email
        this.relation_list[2].value = res.data.address
        this.complete = true
      })
      .finally(() => {});
   }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />